import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Phone, MapPin, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { useSEO, useSettings } from "@/lib/hooks";
import RequestForm from "@/components/sections/RequestForm";
import FAQSection from "@/components/sections/FAQSection";

export default function DepartmentPage() {
  const { slug } = useParams();
  const s = useSettings();
  const [data, setData] = useState({ dept: null, cities: [] });

  useEffect(() => {
    Promise.all([api.get(`/zones/${slug}`), api.get("/zones")]).then(([d, all]) => {
      const dept = d.data;
      const cities = (all.data.cities || []).filter((c) => c.department_code === dept.code);
      setData({ dept, cities });
    }).catch(() => setData({ dept: false, cities: [] }));
  }, [slug]);

  useSEO({ title: data.dept?.meta_title, description: data.dept?.meta_description });

  if (data.dept === false) return <div className="text-center py-32 text-txt-500">Département introuvable.</div>;
  if (!data.dept) return <div className="text-center py-32 text-txt-500">Chargement...</div>;

  return (
    <div className="bg-white">
      <div className="bg-ink-900 text-white py-16">
        <div className="max-w-6xl mx-auto px-4 lg:px-6">
          <div className="inline-flex items-center gap-2 text-brand-300 text-xs uppercase tracking-widest font-bold">
            <MapPin size={14} /> Département {data.dept.code}
          </div>
          <h1 className="text-3xl lg:text-5xl font-extrabold mt-3">{data.dept.h1}</h1>
          <p className="text-ink-200 mt-5 max-w-3xl text-lg leading-relaxed">{data.dept.seo_text}</p>
          <a href={`tel:${s?.company_phone_raw || ""}`} className="mt-6 inline-flex bg-white text-brand-800 hover:bg-brand-50 font-bold rounded-xl px-6 py-3.5 items-center gap-2 transition-colors"><Phone size={18} /> Appel urgent</a>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4 lg:px-6 py-12 grid lg:grid-cols-3 gap-10">
        <div className="lg:col-span-2">
          <div className="bg-surface-50 border border-surface-200 rounded-2xl p-6">
            <h2 className="text-lg font-extrabold text-txt-900">Villes desservies dans le {data.dept.code}</h2>
            <div className="mt-4 grid sm:grid-cols-2 gap-2">
              {data.cities.map((c) => (
                <Link key={c.slug} to={`/depannage-remorquage-${c.slug}`} className="flex items-center justify-between bg-white border border-surface-200 hover:border-brand rounded-xl px-4 py-3 text-sm font-medium transition-colors">
                  <span className="text-txt-900">{c.city}</span>
                  <ArrowRight size={14} className="text-txt-300" />
                </Link>
              ))}
            </div>
          </div>
        </div>
        <div className="bg-white border border-surface-200 rounded-2xl shadow-card overflow-hidden h-fit"><RequestForm compact /></div>
      </div>
      <FAQSection />
    </div>
  );
}
